import type { DatasetBase } from '@core/reports-types';
import { truncateReportsLabel } from '@core/reports-util';

export const categoryNameFormatter = (dataset: DatasetBase) => (id: string) =>
  truncateReportsLabel(dataset.getCategoryNameById(id));
